import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      padding: "16px 1px",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "white",
    },
    drawerButton: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between", // This ensures space between icons
      alignItems: "center",
      width: "100%",
      marginBottom: "20px",
      cursor: "pointer",
      gap: "40px",
    },
    iconWrapper: {
      display: "flex",
      padding: "12px 16px",
      alignItems: "center",
      // gap: "16px",
      borderRadius: "8px",
      cursor: "pointer",
    },
    apaLogoWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginBottom: "20px",
    },
    bottomIcons: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    logoutButton: {
      border: "none",
      backgroundColor: "transparent",
      color: "#D32F2F",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "4px",
      width: "72px",
      minHeight: "40px",
      padding: "8px 4px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: 700,
      fontFamily: "inherit",
      lineHeight: 1,
      userSelect: "none",
      "&:hover": {
        backgroundColor: "#FDECEC",
      },
      "&:focus-visible": {
        outline: "2px solid #D32F2F",
        outlineOffset: "2px",
      },
    },
    logoutIcon: {
      width: "18px",
      height: "18px",
      flexShrink: 0,
    },
  })();
};
